import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteUser } from "../services/users.service";

export const useDeleteUser = (uid: string) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => deleteUser(uid),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ["users"] });
    },
  });
};
